"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.View = View;
const Contexts = __importStar(require("@genesys/client-core/lib/contexts"));
const DebugSettings = __importStar(require("@genesys/client-core/lib/debug-settings"));
const Elements = __importStar(require("@genesys/client-core/lib/elements"));
const GlobalActions = __importStar(require("@genesys/client-core/lib/global-actions"));
const GraphQLQuery = __importStar(require("@genesys/client-core/lib/graphql-query"));
const UserProfile = __importStar(require("@genesys/client-core/lib/user-profile"));
const Authorization = __importStar(require("@genesys/shared/lib/authorization"));
const Guid = __importStar(require("@genesys/shared/lib/guid"));
const graphql_tag_1 = __importDefault(require("graphql-tag"));
const React = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const ClientConfig = __importStar(require("../../../../client-config"));
const Actions = __importStar(require("./actions"));
const clear_cache_1 = require("./clear-cache");
const Impersonation = __importStar(require("./impersonation"));
const SystemModelImport = __importStar(require("./system-model-import"));
const productQuery = (0, graphql_tag_1.default) `
  query DebubViewProduct {
    product {
      routes {
        id
        route
        url
      }
    }
  }
`;
const DebugRoot = styled_components_1.default.div `
  padding: 10px;
`;
function View(props) {
    const openSystem = (systemId, title) => props.dispatch(GlobalActions.requestOpenTab({
        id: Guid.guidFromString(systemId),
        title: title,
        subject: GlobalActions.createSystemEditorSubject(Guid.guidFromString(systemId))
    }));
    const setLoader = (show) => props.dispatch(Actions.setLoader(show));
    const setImpersonationInput = (input) => props.dispatch(Actions.setImpersonationInput(input));
    const setShowImpersonationError = (showError) => props.dispatch(Actions.setShowImpersonationError(showError));
    const isProduction = ClientConfig.config.environment === "Production";
    return (React.createElement(Contexts.clientConfigContext.Consumer, null, (config) => (React.createElement(DebugSettings.DebugSettingsConsumer, null, ({ includeServerLog, setDebugSettings, showHiddenProperties, showHiddenResults }) => (React.createElement(UserProfile.UserProfile, null, ({ applicationClaims }) => (React.createElement(GraphQLQuery.QueryProductSimple, { query: productQuery, variables: {} }, ({ product: { routes } }) => {
        return (React.createElement(React.Fragment, null,
            props.showLoader && (React.createElement(Elements.LoadingOverlay, null,
                React.createElement(Elements.Loader, null))),
            React.createElement(DebugRoot, null,
                React.createElement(DebugSettings.DebugSettingsSelection, { isRestrictedDeveloper: Authorization.checkPermission(applicationClaims, Authorization.genesysUserClaims
                        .restrictedDeveloper), debugSettings: {
                        includeServerLog: includeServerLog,
                        showHiddenProperties: showHiddenProperties,
                        showHiddenResults: showHiddenResults
                    }, setDebugProperties: (debugSettings) => {
                        setDebugSettings(debugSettings.includeServerLog, debugSettings.showHiddenProperties, debugSettings.showHiddenProperties);
                    } }),
                Authorization.checkPermission(applicationClaims, Authorization.genesysUserClaims.resetCache) && (React.createElement(clear_cache_1.ClearCache, { includeServerLog: includeServerLog, servers: routes.map((r) => r.url), isProduction: isProduction, clientConfigContextValue: config })),
                (Authorization.checkPermission(applicationClaims, Authorization.genesysUserClaims.developer) ||
                    Authorization.checkPermission(applicationClaims, Authorization.genesysUserClaims
                        .restrictedDeveloper)) && (React.createElement(SystemModelImport.Component, { openSystem: openSystem, setLoader: setLoader, clientConfigContextValue: config })),
                Authorization.checkPermission(applicationClaims, Authorization.genesysUserClaims.impersonate) && (React.createElement(Impersonation.Component, { setImpersonationInput: setImpersonationInput, setShowImpersonationError: setShowImpersonationError, input: props.impersonationInput, showError: props.showImpersonationError })))));
    }))))))));
}
//# sourceMappingURL=view.js.map